import { clsx } from 'clsx';
import styles from './ValuationWaterfall.module.css';

export interface WaterfallItem {
  label: string;
  value: number;
  kind?: 'start' | 'positive' | 'negative' | 'total';
}

export function ValuationWaterfall({
  items,
  currency = '$',
}: {
  items: WaterfallItem[];
  currency?: string;
}) {
  const max = Math.max(...items.map((item) => Math.abs(item.value)), 1);

  return (
    <div className={styles.root} role="img" aria-label="Valuation waterfall">
      {items.map((item) => {
        const kind =
          item.kind ?? (item.value >= 0 ? 'positive' : 'negative');
        return (
          <div
            key={item.label}
            className={clsx(styles.item, styles[kind])}
          >
            <span className={styles.value}>
              {currency}
              {Math.abs(item.value).toFixed(0)}
            </span>
            <span
              className={styles.bar}
              style={{ height: `${28 + (Math.abs(item.value) / max) * 92}px` }}
            />
            <span className={styles.label}>{item.label}</span>
          </div>
        );
      })}
    </div>
  );
}
